import { DataManagement } from './DataManagement';
import { getSection } from '@/config/navigation';
import { PageSection } from '@/components/ui/page-section';

export function DataManagementSection() {
  const section = getSection('data-management');

  return (
    <PageSection section={section}>
      <DataManagement portalTargetId="portal-root" />
    </PageSection>
  );
}